import React from 'react'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'
import { Link } from 'react-router-dom'

const teamPic = `/public/team.jpg`

const MeetTheTeam = styled(props => {
  return (
    <div {...props}>
      <MeetTheTeamBackground />
      <MeetTheTeamForeground>
        <div css='flex-grow: 1;'></div>
        <div css='background-color: rgba(30, 30, 30, 0.5); padding: 20px; display: flex; flex-direction: column;'>
          <div css='color: white; max-width: 1140px; align-self: center;'>We are a diverse team of researchers, clinicians, students and software developers</div>
          <MeetTheTeamButton to='/team'>MEET THE TEAM</MeetTheTeamButton>
        </div>
      </MeetTheTeamForeground>
    </div>
  )
})`
  height: 600px;
  position: relative;
`
const MeetTheTeamButton = styled(Link)`
  font-size: 26px;
  padding: 15px;
  border: 4px solid ${inheritPrimaryColor};
  background-color: transparent;
  align-self: center;
  font-weight: 700;
  margin: 20px 0px;
  color: ${inheritPrimaryColor};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s, background-color 0.2s;
  &:hover {
    background-color: ${inheritPrimaryColor};
    color: white;
  }
`
const MeetTheTeamBackground = styled.div`
  background-image: url('${teamPic}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  will-change: transform;
`
const MeetTheTeamForeground = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  /* padding: 30px; */
  color: white;
  z-index: 100;
  /* background-color: rgba(30, 30, 30, 0.5); */
  font-weight: 200;
  font-size: 26px;
  /* backdrop-filter: blur(2px) saturate(80%); */
`

export default MeetTheTeam